// extracted by mini-css-extract-plugin
export var createdDate = "_nn-1";
export var divider = "_nn-2";
export var headerDivider = "_nn-3";
export var messagesCard = "_nn-0";
export var messagesContainer = "_nn-7";
export var messagesContainerWrapper = "_nn-4";
export var pointerCapturingButtonBoxes = "_nn-a";
export var showLeftPanelButton = "_nn-9";
export var showMoreButton = "_nn-c";
export var showMoreButtonContainer = "_nn-b";
export var summaryTitle = "_nn-6";
export var systemMessageCardWrapper = "_nn-d";
export var topButtons = "_nn-8";
export var withPadding = "_nn-5";